import Swiper from "swiper";
class SwiperSetupClass {
	constructor() {
		this.swiperList = {};
		this.templates = {};
		window.swiperList = this.swiperList;
	}

	register(id, configFactory) {
		if (this.templates[id]) {
			console.warn(`Template with ID '${id}' already exists.`);
			return false;
		}
		this.templates[id] = configFactory;
		return this;
	}

	init(holder = document) {
		const swipers = holder.querySelectorAll('[data-swiper]');
		if (swipers.length) this._createSwipers(swipers);
		return this;
	}

	async destroy(holder = document, erase = true) {
		const isHolderSwiper = holder?.dataset?.swiperId;
		if (isHolderSwiper && this.swiperList.hasOwnProperty(isHolderSwiper)) {
			await this.swiperList[isHolderSwiper].destroy();
			return;
		}

		const swipers = holder.querySelectorAll('[data-swiper-id]');
		if (swipers && swipers.length) {
			await Promise.all(Array.from(swipers).map(async (swiper) => {
				const id = swiper.dataset.swiperId;
				if (this.swiperList.hasOwnProperty(id)) {
					try {
						await this.swiperList[id].destroy();
					} catch (e) {
						console.error(`Error destroying swiper with ID ${id}:`, e);
					}

					if (erase) {
						swiper.removeAttribute('data-swiper-id');
						delete this.swiperList[id];
					}
				}
			}));
		}
		return this;
	}

	// Update all swipers or a specific one: forces Swiper to recalculate its dimensions and update its internal state.
	update(swiperId = null) {
		if (swiperId && this.swiperList[swiperId]) {
			this.swiperList[swiperId].update();
			return;
		}

		Object.values(this.swiperList).forEach(swiper => {
			try {
				swiper.update();
			} catch (e) {
				console.error('Error updating swiper:', e);
			}
		});
	}

	_createSwipers(elements) {
		elements.forEach(element => {
			// Skip if already initialized
			if (element.getAttribute('data-swiper-id') && !document.body.classList.contains('wp-admin')) return;

			const templateId = element.getAttribute('data-swiper');
			if (!this.templates[templateId]) {
				console.error(`No swiper template registered for ID: ${templateId}`);
				return;
			}

			// Create a unique ID for this swiper instance
			const swiperId = 'swiper_' + Date.now() + '_' + Math.floor(Math.random() * 1000);
			element.setAttribute('data-swiper-id', swiperId);

			const nodeInfo = {
        swiperId,
        swiperTag: `[data-swiper-id="${swiperId}"]`,
        swiperEl: element
      };

			try {
				// Get configuration from the template factory
				const config = this.templates[templateId](nodeInfo);

				// Initialize the swiper with the configuration
				const swiperInstance = new Swiper(nodeInfo.swiperTag, config);

				// Store the instance
				this.swiperList[swiperId] = swiperInstance;
			} catch (error) {
				console.error(`Error initializing swiper with ID ${templateId}:`, error);
			}
		});
	}
}

export const SwiperSetup = new SwiperSetupClass();
